/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S61_IntroInputs */

const es_tyc_liability_s61_intro = /** @type {(inputs: Tyc_Liability_S61_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la maxima medida permitida por la ley, Nexata no sera responsable por danos indirectos, incidentales, especiales o punitivos derivados de:`)
};

const en_tyc_liability_s61_intro = /** @type {(inputs: Tyc_Liability_S61_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To the maximum extent permitted by law, Nexata shall not be liable for indirect, incidental, special, or punitive damages arising from:`)
};

/**
* | output |
* | --- |
* | "To the maximum extent permitted by law, Nexata shall not be liable for indirect, incidental, special, or punitive damages arising from:" |
*
* @param {Tyc_Liability_S61_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s61_intro = /** @type {((inputs?: Tyc_Liability_S61_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S61_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s61_intro(inputs)
	return en_tyc_liability_s61_intro(inputs)
});
export { tyc_liability_s61_intro as "tyc.liability.s61_intro" }